const USP = () => {
  return (
    <>
    <section className="app-section container-fluid py-4 py-md-5">
        <div className="container px-3 px-md-0">

            <div className="row text-start py-4 align-items-center">
                <div className="col-12 col-md">
                    <h4 className="fw-bold fs-4 fs-md-4 mb-0">Why should you book your flights with us?</h4>
                </div>
               
                <div className="col-12 col-md-3 d-none d-lg-flex justify-content-end">
                    <a href="/aboutus"
                       className="btn btn-outline-orange btn-lg rounded-0 w-100">
                        <span>Find out more</span>
                    </a>
                </div>
                    
            </div>

            <div className="row row-cols-md-3 gy-4 pt-4 pb-5 pb-0">
                <div className="container">
                    <div className="row align-items-start">
                        <i className="icon-shield glyph-md tf-orange col-auto"></i>
                        <div className="col">
                            <p className="fs-5 fw-bold mb-4">Financial protection</p>
                            <p>Your booking is safeguarded with a unique set of financial security measures.</p>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row align-items-start">
                        <i className="icon-flight glyph-md tf-orange col-auto"></i>
                        <div className="col">
                            <p className="fs-5 fw-bold mb-4">Tailored flight options</p>
                            <p>Including stopovers, one-way upgrades, flexible tickets and complex route itineraries.
                            </p>

                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row align-items-start">
                        <i className="icon-headset glyph-md tf-orange col-auto"></i>
                        <div className="col">
                            <p className="fs-5 fw-bold mb-4">24/7/365 UK-based support</p>
                            <p>Speak to a real person, not a chat-bot. Often solving problems before you knew they
                                existed.</p>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row align-items-start">
                        <i className="icon-trip_hub glyph-md tf-orange col-auto"></i>
                        <div className="col">
                            <p className="fs-5 fw-bold mb-4">Expert travel consultants</p>
                            <p>Our consultants have been to 99% of the world's countries, offering personalised advice.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row align-items-start">
                        <i className="icon-calendar_light glyph-md tf-orange col-auto"></i>
                        <div className="col">
                            <p className="fs-5 fw-bold mb-4">Hassle free</p>
                            <p>The average booking is impacted by 2 schedule changes. We address this without stress or
                                cost to you.</p>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row align-items-start">
                        <i className="icon-checked_baggage glyph-md tf-orange col-auto"></i>
                        <div className="col">
                            <p className="fs-5 fw-bold mb-4">Inclusive fares</p>
                            <p>All flights include at least 20kg of baggage, with no hidden fees.</p>
                        </div>
                    </div>
                </div>

                
            </div>

            {/* Only show button when on mobile/tablet view at the bottom of the section */}
            <div className="col-12 d-lg-none mt-0 justify-content-center text-center">
                <a href="/aboutus"
                    className="btn btn-outline-orange btn-lg rounded-0 px-5 mb-4 w-80">
                    Find out more
                </a>
            </div> 
          
        </div>
    </section>

    </>
  )
}

export default USP
